import axios from './axios';
import { VBQL_RESOURCE_URL, API_VERSION } from './config';
import transformQueryResultResponse from './transformers/queryResultTransformers';

export const postQuery = async ({ bearerToken }, query) => {
  try {
    const response = await axios({
      url: '/analytics/vbql',
      method: 'post',
      data: query.vbql,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'text/plain',
      },
    });

    return transformQueryResultResponse(response.data);
  } catch (err) {
    throw (err);
    // TODO: handle errors
  }
};

export default {
  postQuery,
};
